export function loadMatchScreen() {
  return import("./MatchScreen.js");
}

export function preloadMatchScreen(): void {
  void loadMatchScreen();
}
